import { Component, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


import { AppService } from 'src/app/app.service';

@Component({
    selector: 'app-signup-prompt-dialog',
    templateUrl: './signup-prompt-dialog.component.html',
    styleUrls: ['./signup-prompt-dialog.component.scss'],
    standalone: false
})
export class SignupPromptDialogComponent {
	args = {
		descCaption: '_LOYALTY.sprompt_desc',
		approveCaption: '_LOYALTY.sprompt_ok',
		cancelCaption: '_LOYALTY.sprompt_cancel',
		licenseCaption: '_LOYALTY.sprompt_license'
	}
	constructor(
		public appService: AppService,
		public dialogRef: MatDialogRef<SignupPromptDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		console.log(this.data.workMode);
		switch (this.data.workMode) {
			case "tabOrder": ; case "tableOrderCreate": ; case "tableOrderJoin":
				this.args = {
					descCaption: '_LOYALTY.sprompt_desc_tabitorder',
					approveCaption: '_LOYALTY.sprompt_ok_tabitorder',
					cancelCaption: '_LOYALTY.sprompt_cancel_tabitorder',
					licenseCaption: '_LOYALTY.sprompt_license_tabitorder'
				}
				break;
			case "tabitOrder":
				this.args = {
					descCaption: '_LOYALTY.sprompt_desc_tabitorder',
					approveCaption: '_LOYALTY.sprompt_ok_tabitorder',
					cancelCaption: '_LOYALTY.sprompt_cancel_tabitorder',
					licenseCaption: '_LOYALTY.sprompt_license_tabitorder'
				}
				break;
			case "addItems":
				this.args = {
					descCaption: '_LOYALTY.sprompt_desc_additems',
					approveCaption: '_LOYALTY.sprompt_ok_additems',
					cancelCaption: '_LOYALTY.sprompt_cancel_additems',
					licenseCaption: '_LOYALTY.sprompt_license_additems'
				}
				break;

		}
	}


  ngOnInit() {
  }

}
